
import { takeUntil } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  NgZone,
  AfterViewChecked,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ActivatedRoute, Router } from "@angular/router";
import { Product } from "../../shared/interface/product";
import { Subject } from "rxjs";
import { FeaturedProduct } from "../../shared/interface/featured-product";
import { ProductService } from "../product.service";
import * as productActions from "../product.actions";
import * as reducers from "../../reducers";
import { ProductCompare } from "../../shared/interface/product-compare";
import {
  resizeImg,
  changeDRId,
  showOverlay,
  showImgError,
  getBuyButtonText,
  getPriceIntegerDot,
  getPriceDecimal,
  extractDRPriceIntegerDot,
  extractDRPriceDecimal,
  productName,
} from "../../shared/utils/utils";
import * as $ from "jquery";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";

@Component({
  selector: "featured-product",
  encapsulation: ViewEncapsulation.None,
  templateUrl: './featured-product.component.html',
  styleUrls: ['./featured-product.component.scss'],
})
export class FeaturedProductComponent implements OnInit, AfterViewChecked {
  @Input() screenWidth: string;
  @Input() viewportType: string;
  //@Input() featuredProduct: FeaturedProduct;
  @Input() productCompare: ProductCompare[];
  @Input() suggestedProduct;
  @Output() fpLoaded = new EventEmitter();
  @Output() hatchOverlayDisplay = new EventEmitter();
  @ViewChild("drId") drId: ElementRef;
  locale: string;
  thumbnailW: number = 300;
  thumbnailH: number = 169;
  thumbnailWSM: number = 270;
  thumbnailHSM: number = 152;

  changeDRId;
  productName;
  showImgError;
  getBuyButtonText;
  getPriceIntegerDot;
  getPriceDecimal;
  extractDRPriceIntegerDot;
  extractDRPriceDecimal;
  featuredProduct: FeaturedProduct;
  destroy$: Subject<boolean> = new Subject<boolean>();
  afterViewChecked: boolean = false;
  drLoading: boolean = false;

  constructor(
    private store: Store<reducers.State>,
    private zone: NgZone,
    private elRef: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.productName = productName;
    this.changeDRId = changeDRId;
    this.showImgError = showImgError;
    this.getBuyButtonText = getBuyButtonText;
    this.getPriceIntegerDot = getPriceIntegerDot;
    this.getPriceDecimal = getPriceDecimal;
    this.extractDRPriceIntegerDot = extractDRPriceIntegerDot;
    this.extractDRPriceDecimal = extractDRPriceDecimal;
  }

  ngOnInit() {
    this.store
      .select(reducers.getProductFeatured)
      .subscribe((featuredProduct) => {
        this.featuredProduct = featuredProduct;
        this.afterViewChecked = false;
      });

    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.locale = params["locale"];
    });
  }

  ngAfterViewChecked() {
    if (!this.afterViewChecked && this.featuredProduct) {
      // 	$('.js-product-item').addClass('dr-loading');
      this.afterViewChecked = true;
      this.fpLoaded.emit(this.afterViewChecked);
    }
  }

  getEANCode(productUPC) {
    return productUPC;
  }

  createThumbnail(img) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      //add if(img.naturalWidth && img.naturalHeight) {} to make sure has img
      resizeImg(img, this.thumbnailWSM, this.thumbnailHSM, this.locale);
    } else {
      resizeImg(img, this.thumbnailW, this.thumbnailH, this.locale);
    }
  }

  showOverlay(productDetail) {
    let popupFlag = false;
    if (popupFlag == false) {
      popupFlag = true;
      showOverlay(
        productDetail,
        this.locale,
        this.store,
        this.hatchOverlayDisplay
      );
    }
  }

  checkOfferType(bundle, offerType) {
    try {
      return bundle ? bundle.indexOf(offerType) != -1 : false;
    } catch (err) {
      console.log(err);
      return false;
    }
  }
  getOfferTypeText(bundle, offerType) {
    var offerArray = bundle.split("=#=");
    var offerVal = "";
    for (var oi = 0; oi < offerArray.length; oi++) {
      var offerTypeValue = offerArray[oi].split("=");


      if (offerTypeValue.length > 0 && offerTypeValue[0] === offerType) {
        offerVal = offerTypeValue[1];
      }
    }
    return offerVal;
  }

  compareProduct(productUPC, addRemoveCompare) {
    if (addRemoveCompare === "Compare") {
      if (this.productCompare.indexOf(null) > -1) {
        this.store.dispatch(
          new productActions.AddComparedProduct({ upc: productUPC, type: 0 })
        );
      }
    } else {
      this.store.dispatch(new productActions.RemoveComparedProduct(productUPC));
    }
    //if(this.locale == 'en-us'){
    //window['hatchwidgetHelpers'].reloadScript();
    window["hatchwidgetHelpers"].reloadScript();
    //    }
    $(".js-product-item").removeData();
    //setTimeout(function(){window['appSetupHelpers'].scanPID()},500);
    this.afterViewChecked = true;
  }

  transmitToCart() {
    var that = this;
    setTimeout(() => {
      $(".cart-main-section .cart__empty")[0] &&
        ($(".cart-main-section .cart__empty")[0].innerHTML =
          that.translate.instant("empty_cart"));
      $(".cart-main-section .cart__title")[0] &&
        ($(".cart-main-section .cart__title")[0].innerHTML =
          that.translate.instant("cart"));
      $(".cart-main-section .cart__items").each(function () {
        $(this)
          .find(".cart_remove .cart-item__remove")
          .each(function (i) {
            $(".cart_remove .cart-item__remove")[i].innerHTML =
              that.translate.instant("remove");
          });
      });
      $(".cart-main-section .cart__checkout-button")[0] &&
        ($(".cart-main-section .cart__checkout-button")[0].innerHTML =
          that.translate.instant("checkout"));
    }, 100);
  }
}
